<template>
  <v-card class="rounded-card card-shadow" color="primary">
    <v-card-title class="white--text font-weight-bold pl-5">
      Vendas por dia
    </v-card-title>
    <figure style="width: 100%;">
      <v-chart :options="chart"
               ref="vendasDiasChart"
               theme="primarydark"
               autoresize/>
    </figure>
  </v-card>
</template>

<script>
import moment from 'moment';
import { toEchartData } from '@/utils/chart-utils';
import chartMixin from '@/mixins/chart-mixin';
import {
  formatToCode,
  VIEW_FORMAT,
} from '@/utils/moment-date-utils';
import IndicadoresMarketplaceService from './indicadores-marketplace';


export default {
  mixins: [chartMixin],
  props: {
    stateDate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      vendasDias: null,
      chart: null,
    };
  },
  computed: {
    query() {
      return `dataCompra >= ${this.stateDate.initialDate} and dataCompra <= ${this.stateDate.finalDate}`;
    },
  },
  methods: {
    showLoading() {
      this.$refs.vendasDiasChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      this.$refs.vendasDiasChart.hideLoading();
    },
    buildChart(data) {
      return {
        width: '80%',
        tooltip: {
          trigger: 'axis',
          formatter: this.tooltipFormatterAxis,
        },

        dataset: {
          source: [
            ['Orders'],
            ...toEchartData(data, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'category',
          interval: 1,
          maxInterval: 1,
        },
        yAxis: {
          splitNumber: 8,
          axisLabel: {
            formatter: this.axisMoneyFormatter,
          },
        },
        grid: {
          top: '15px',
          left: '16%',
        },
        series: [
          {
            type: 'bar',
            barMaxWidth: 12,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
    },
    buildDataPoints(data) {
      const start = moment(this.stateDate.initialDate);
      const endDate = moment(this.stateDate.finalDate);

      const dataPoints = [];

      while (start.isSameOrBefore(endDate)) {
        dataPoints.push({
          description: start.format(VIEW_FORMAT),
          value: data[formatToCode(start)] || 0,
        });
        start.add(1, 'day');
      }
      this.chart = this.buildChart(dataPoints);
    },
    getComprasPorDia() {
      this.showLoading();
      IndicadoresMarketplaceService.getComprasPorDia({
        query: this.query,
      })
        .then(({ data }) => {
          this.vendasDias = data;
          this.buildDataPoints(this.vendasDias);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  watch: {
    stateDate(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getComprasPorDia();
    },
  },
  mounted() {
    this.getComprasPorDia();
  },
};
</script>

<style scoped>
figure .echarts {
  width: 100%;
  height: 300px;
  /*max-width: 400px;*/
}
</style>
